<template>
  <div class="withdraw-container">
    <van-nav-bar :title="$t('withdraw')" left-text="返回" left-arrow>
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
      <template #right>
        <img
          @click="goRecord"
          class="record"
          src="../../assets/recharge-record.svg"
          alt=""
        />
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="type-select">
        <div class="type-select-left">{{ $t("withdrawal_currency") }}</div>
        <div class="type-select-right" @click="show = true">
          <img
            v-if="currentType.name && currentType.name.startsWith('USDT')"
            src="../../assets/USDT.png"
            class="logo"
            alt=""
          />
          <img
            v-if="currentType.name == 'BTC'"
            src="../../assets/BTC.png"
            class="logo"
            alt=""
          />
          <img
            v-if="currentType.name == 'ETH'"
            src="../../assets/ETH.png"
            class="logo"
            alt=""
          />
          {{ currentType.name }}
          <img src="../../assets/picker-arrow.svg" class="arrow" alt="" />
        </div>
      </div>
      <div class="input-row">
        <div class="input-row-top">
          <div class="input-row-top-title">
            {{ $t("withdrawal_Amount_Available") }}:
          </div>
          <div class="input-row-top-amount">
            {{ userInfo.balance_usdt }}&nbsp;&nbsp;USDT
          </div>
        </div>
        <div class="input-row-bot">
          <div class="input-bar">
            <input
              type="text"
              v-model="withdrawMoney"
              inputmode="decimal"
              :placeholder="$t('withdrawal_Please_enter_amount')"
            />
            <div class="all" @click="withdrawMoney = userInfo.balance_usdt">
              {{ $t("withdrawal_remove_all") }}
            </div>
          </div>
        </div>
      </div>
      <div class="input-row">
        <div class="input-row-top">
          <div class="input-row-top-title">{{ $t("withdrawal_address") }}</div>
        </div>
        <div class="input-row-bot">
          <div class="input-bar">
            <input :disabled="isNeedPassword != 'need'"
              v-model="address"
              type="text"
              :placeholder="$t('withdrawal_Please_enter_address')"
            />
          </div>
        </div>
      </div>
      <div class="input-row" v-if="isNeedPassword == 'need'">
        <div class="input-row-top">
          <div class="input-row-top-title">{{ $t("withdrawal_password") }}</div>
        </div>
        <div class="input-row-bot">
          <div class="input-bar">
            <input
              :type="pwdType"
              v-model="withdrawPassword"
              :placeholder="$t('withdrawal_Please_enter_password')"
            />
            <div class="eye">
              <img
                v-if="pwdType == 'text'"
                @click="pwdType = 'password'"
                src="../../assets/eye.svg"
                alt=""
              />
              <img
                v-if="pwdType == 'password'"
                @click="pwdType = 'text'"
                src="../../assets/close-eye.svg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="confirm-btn" @click="withdraw">{{ $t("confirm") }}</div>
      <div class="withdraw-tip" v-if="hideWithdrawTip !== 'true'">
        <div class="withdraw-tip-top">
          {{ $t("withdrawal_handling_fee") }}:&nbsp;&nbsp;<span
            v-if="(currentType.withdraw_fee*100) >= 0"
            >{{ currentType.withdraw_fee*100 }}%</span
          >
        </div>
        <div class="withdraw-tip-bot">
          {{ $t("withdrawal_Reminder_text") }}
        </div>
      </div>
    </div>
    <van-action-sheet
      :cancel-text="$t('cancel')"
      close-on-click-action
      v-model="show"
      :actions="actions"
      @select="onSelect"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      pwdType: "password",
      show: false,
      currentType: "",
      actions: [],
      userInfo: "",
      withdrawMoney: "",
      address: "",
      withdrawPassword: "",
      withdrawConfig: "",
      isNeedPassword: '',
      hideWithdrawTip: ''
    };
  },
  async created() {
    // if(localStorage.getItem("userInfo")) {
    //   this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // } else {
    //   location.reload()
    // }
    console.log(this.$router.history._startLocation)
    console.log(this.$route)
    this.getWithdrawConfig();
  },
  async mounted() {
    this.hideWithdrawTip = process.env.VUE_APP_HIDE_WITHDRAW_TIP
    this.isNeedPassword = process.env.VUE_APP_WITHDRAW_PASS
    if(localStorage.getItem('addData')) {
      this.address = localStorage.getItem('addData')
    }
    await this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      const res = await this.$api.getUserInfo();
      if (res.code == 200) {
        this.userInfo = res.data;
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      } else if(res.code == 10401) {
        // location.reload()
      }
    },
    async withdraw() {
      let data = {
        money: this.withdrawMoney,
        config_id: this.currentType.id,
        address: this.address,
        password: this.withdrawPassword,
      };
      if(this.isNeedPassword != 'need') {
        data.address = 'self'
      }
      const res = await this.$api.withdraw(data);
      if (res.code == 200) {
        this.$Toast(this.$t("withdrawal_success"));
        setTimeout(() => {
          this.$router.push("/withdraw-record");
        }, 1000);
      } else {
        this.$Toast(res.message);
      }
    },
    async getWithdrawConfig() {
      const res = await this.$api.getWithdrawConfig();
      if (res.code == 200) {
        this.actions = res.data.map((item) => {
          return {
            id: item.id,
            currency: item.currency,
            name: item.type,
            address: item.address,
            max_money: item.max_money,
            min_money: item.min_money,
            withdraw_fee: item.handling_fee_rate,
          };
        });
        if(localStorage.getItem('currentCurrency') == 'trx') {
          this.currentType = this.actions.filter(item=> item.name == 'USDT-TRC')[0];
        } else if(localStorage.getItem('currentCurrency') == 'bnb') {
          this.currentType = this.actions.filter(item=> item.name == 'USDT-BSC')[0];
        } else {
          this.currentType = this.actions.filter(item=> item.name == 'USDT-ERC')[0];
        }
        // this.currentType = this.actions[0];
        console.log(this.currentType)
      }
    },
    onSelect(e) {
      console.log(e);
      this.currentType = e;
    },
    navBack() {
      this.$router.replace("/user");
    },
    goRecord() {
      this.$router.push("/withdraw-record");
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  width: 30px;
  height: 15px;
}
.record {
  width: 40px;
  height: 60px;
}
.content {
  background: #fff;
  margin-top: 10px;
  min-height: calc(100vh - 56px);
  box-sizing: border-box;
  padding: 15px;
  .type-select {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
    &-right {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      .logo {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      .arrow {
        width: 15px;
        height: 10px;
        margin-left: 5px;
        margin-top: 5px;
      }
    }
  }
  .input-row {
    margin-top: 10px;
    &-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-title {
        font-size: 12px;
        color: #7f8aa1;
      }
      &-amount {
        font-size: 14px;
        font-weight: bold;
        color: #0062f8;
      }
    }
    &-bot {
      margin-top: 15px;
      .input-bar {
        display: flex;
        align-items: center;
        background: #f2f4f7;
        padding-right: 15px;
        border-radius: 3px;
        input {
          flex: 1;
          color: #222;
          border: none;
          background: transparent;
          font-weight: bold;
          font-size: 14px;
          padding: 13px 10px;
        }
        .all {
          height: 100%;
          padding: 5px 15px;
          color: #fff;
          background: #0062f8;
          font-size: 12px;
          border-radius: 3px;
        }
        .eye {
          img {
            width: 25px;
            height: 15px;
          }
        }
      }
    }
  }
  .confirm-btn {
    width: 100%;
    padding: 10px 0;
    background: #0062f8;
    color: #fff;
    text-align: center;
    margin-top: 40px;
    border-radius: 3px;
  }
  .withdraw-tip {
    margin-top: 40px;
    &-top {
      font-size: 14px;
      font-weight: bold;
    }
    &-bot {
      font-size: 14px;
      line-height: 2;
      margin-top: 10px;
    }
  }
}
@media (min-width: 640px) {
  /deep/ .van-nav-bar__content {
    height: auto;
  }
  /deep/ .van-nav-bar--fixed {
    width: 540px;
    height: 100px;
    left: unset;
  }
  /deep/ .van-popup--bottom {
    width: 540px;
    left: unset;
  }
  .back {
    width: 30px;
    height: 15px;
  }
  .record {
    width: 40px;
    height: 60px;
  }
  .content {
    background: #fff;
    margin-top: 10px;
    min-height: calc(100vh - 56px);
    box-sizing: border-box;
    padding: 15px;
    .type-select {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 40px;
      &-right {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
        .logo {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
        .arrow {
          width: 15px;
          height: 10px;
          margin-left: 5px;
          margin-top: 5px;
        }
      }
    }
    .input-row {
      margin-top: 10px;
      &-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-title {
          font-size: 12px;
          color: #7f8aa1;
        }
        &-amount {
          font-size: 14px;
          font-weight: bold;
          color: #0062f8;
        }
      }
      &-bot {
        margin-top: 15px;
        .input-bar {
          display: flex;
          align-items: center;
          background: #f2f4f7;
          padding-right: 15px;
          border-radius: 3px;
          input {
            flex: 1;
            color: #222;
            border: none;
            background: transparent;
            font-weight: bold;
            font-size: 14px;
            padding: 13px 10px;
          }
          .all {
            height: 100%;
            padding: 5px 15px;
            color: #fff;
            background: #0062f8;
            font-size: 12px;
            border-radius: 3px;
          }
          .eye {
            img {
              width: 25px;
              height: 15px;
            }
          }
        }
      }
    }
    .confirm-btn {
      width: 100%;
      padding: 10px 0;
      background: #0062f8;
      color: #fff;
      text-align: center;
      margin-top: 40px;
      border-radius: 3px;
    }
    .withdraw-tip {
      margin-top: 40px;
      &-top {
        font-size: 14px;
        font-weight: bold;
      }
      &-bot {
        font-size: 14px;
        line-height: 2;
        margin-top: 10px;
      }
    }
  }
}
</style>